import { render } from "./Solopreneurship.vue?vue&type=template&id=56f558be&scoped=true"
import script from "./Solopreneurship.vue?vue&type=script&lang=js"
export * from "./Solopreneurship.vue?vue&type=script&lang=js"

import "./Solopreneurship.vue?vue&type=style&index=0&id=56f558be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f558be"]])

export default __exports__